/**
 * ============================================================
 * KEJJA OS — src/lib/offboardingApi.ts
 * ============================================================
 */

import { api } from '@/lib/api';

export const offboardingApi = {
  leaveHome:         (homeId: string) => api.post<{ ok: true }>(`/homes/${homeId}/leave`, {}),
  transferOwnership: (homeId: string, toUserId: string) => api.post<{ ok: true }>(`/homes/${homeId}/transfer-ownership`, { toUserId }),
  deleteHome:        (homeId: string) => api.delete<{ ok: true }>(`/homes/${homeId}`),
  deleteAccount:     () => api.post<{ ok: true; orphanedHomes: number }>(`/auth/delete-account`, {}),
};
